import _ from 'lodash';
import fetchWithCache from './fetchWithCache';

const toQueryString = params =>
  Object.keys(params)
    .filter(x => params[x])
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');

const getQueryParams = (modelInfo, state) => {
  const { config, params, rpos } = state;
  const { selections, style, bodyType } = config;
  const { brandBase, country, language, year, carline, bodyStyle } = modelInfo;

  const code = style.vehicleInfo.code;
  const peg = code.replace(/^.+_/, '');

  const selectedOptions = rpos.filter(option => option !== peg).join('|');

  const queryParams = {
    options: selectedOptions,
    color: selections.exteriorColor,
    interior: selections.interiorColor,
    drive: selections.driveType,
    caller: 'byo',
    mmc: code.replace(/_.*/, ''),
    peg: peg,
    'x-zipcode': params.postalCode,
    'x-bodystyle': bodyStyle,
    'x-brand': brandBase,
    'x-carline': carline,
    'x-country': country,
    'x-language': language,
    'x-modelyear': year
  };

  return _.assign([], queryParams, {
    configuration: bodyType && bodyType.formattedConfig,
    format: 'JSON',
    ref: 'BYO',
    ss: 'SSH'
  });
};

const fetchInventoryCount = (modelInfo, state) => {
  const url = modelInfo.inventoryCountUrl;
  const queryParams = getQueryParams(modelInfo, state);
  return fetchWithCache(`${url}?${toQueryString(queryParams)}`);
};

export default fetchInventoryCount;
